import { render, staticRenderFns } from "./configuration-local-assays-sections-modal.vue?vue&type=template&id=7871df28&scoped=true&"
import script from "./configuration-local-assays-sections-modal.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-sections-modal.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-sections-modal.scss?vue&type=style&index=0&id=7871df28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7871df28",
  null
  
)

export default component.exports